import { useEffect, useState, useContext } from "react";
import { startOfDay, endOfDay } from "date-fns";
import Map from "../Components/map";
import $ from "jquery";
import "rsuite/dist/rsuite.min.css";
import { useTranslation } from "react-i18next";
import Filter from "../Components/Filter";
import FilterContext from "../Hooks/Context";
import { Epoch } from "../Hooks/Common";
import {factoryStartEndTime} from '../Hooks/Common'

const Dashboard = () => {
  
  const [menuStatus, SetMenuStatus] = useState(false);
  const [mapVisiblity, SetMapVisiblity] = useState(true);
  const [updateData, SetUpdateData] = useState();
  const [liveStatus, SetLiveStatus] = useState(true);
  const filterQueries = useContext(FilterContext);
  const { t } = useTranslation();

  $(document).ready(function () {
    $(document).off("click", ".close-marker-icon");
    $(document).on("click", ".close-marker-icon", function (event) {
      SetMapVisiblity(false);
      let filterRequestQuery = {
        factory: "",
        lines: "",
        shift: "",
        startTs: Epoch(startOfDay(new Date())),
        endTs: Epoch(endOfDay(new Date())),
        // selectedMenu: '#factoryOverview',
        ...filterQueries.filterRequestQuery
      };
      filterQueries.GenerateFilters(filterRequestQuery);
      localStorage.setItem("currentMenu", '#factoryOverview');
      window.location.href = "#/factoryOverview";
    });
  });

      /* Live Module Starts from Here */

      const [pauseLive, SetPauseLive] = useState(false);
      const [timeInterval, setTimeInterval] = useState(0);
      var timeout, timeIntervalCount;
    
      const EnableLiveData = (event) => {
        SetPauseLive(false);
    
        let fset = factoryStartEndTime()
        let startDate = fset.startTs
        let endDate = fset.endTs
      
        let filterRequestQuery = JSON.parse(JSON.stringify(filterQueries.filterRequestQuery));
        filterRequestQuery.isLive = true;
        filterRequestQuery.startTs = startDate;
        filterRequestQuery.endTs = endDate;
        filterQueries.GenerateFilters(filterRequestQuery);
      }
    
      useEffect(() => {
        if(!pauseLive) {
          timeout = setTimeout(() => {
            timeIntervalCount = setTimeInterval(timeInterval + 1);
            }, 60000);
        }
      });
    
      useEffect(() => {
        if (filterQueries) {
          SetUpdateData(!updateData);
        }
      },[ filterQueries ]);
    
      useEffect(() => {
        if(filterQueries.filterRequestQuery.isLive) {
          SetPauseLive(false);
        } else {
          SetPauseLive(true);
        }
      },[ filterQueries.filterRequestQuery ]);
    
      useEffect(() => {
        let myDate = new Date( filterQueries.filterRequestQuery.startTs *1000);
        let gmtString = myDate.toGMTString();
        if(filterQueries.filterRequestQuery.isLive) {
          let filterRequestQuery = JSON.parse(JSON.stringify(filterQueries.filterRequestQuery));
          filterRequestQuery.isLive = true;
          filterQueries.GenerateFilters(filterRequestQuery);
        } else {
          let filterRequestQuery = JSON.parse(JSON.stringify(filterQueries.filterRequestQuery));
          filterRequestQuery.isLive = false;
          filterQueries.GenerateFilters(filterRequestQuery);
          clearTimeout(timeout);
          clearInterval(timeIntervalCount);
        }
        
      }, [timeInterval]);
    
      /* Live Module Ends from Here */

  const ToggleClass = () => {
    SetMenuStatus(!menuStatus);
  };

  return (
    <>
      <h4>{ t("LT_company_overview") }</h4>
      { !pauseLive && (
        <span className="liveStatus">
          { t("LT_live") }{" "}
          <span
            className={`showLive ${liveStatus ? "live-icon" : "relay"}`}
          ></span>
        </span>
      )}
      { pauseLive && <div className='live-btn' onClick={ (event) => { EnableLiveData(event) } }>{t("LT_enable_live_data")}</div>}
      <Filter showDatePicker={false} startDate={filterQueries.filterRequestQuery.startTs*1000} endDate={filterQueries.filterRequestQuery.endTs*1000}/>

      <div id="dashboard">
        {filterQueries.filterRequestQuery && (
          <Map
            language={filterQueries.language}
            key={updateData}
            filterQuery={filterQueries}
          />
        )}
      </div>
    </>
  );
};

export default Dashboard;
